import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="32542" id="hero" className="relative min-h-[85vh] w-full flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full bg-[url(/img/south_florida_home.jpg)] bg-cover bg-center bg-no-repeat" aria-hidden="true" />
        {}
        <div className="absolute inset-0 bg-secondary/60 z-10" />
        <div className="absolute inset-0 bg-gradient-to-t from-secondary/80 via-transparent to-secondary/40 z-10" />
      </div>

      {}
      <div ref={ref} className={cn("relative z-20 container mx-auto px-4 text-center flex flex-col items-center max-w-5xl transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        {}
        <span className="block text-primary text-lg md:text-[1.25rem] leading-[1.6] font-mono font-medium mb-6 tracking-widest uppercase drop-shadow-md">
          RESIDENTIAL SERVICES
        </span>

        {}
        <h1 className="text-white font-extrabold font-sans text-4xl md:text-5xl lg:text-[72px] tracking-tighter leading-[1.1] mb-8 drop-shadow-lg">
          Professional Home <br className="hidden md:block" />
          Inspections
        </h1>

        {}
        <p className="text-white/90 text-base md:text-[20px] font-medium max-w-2xl mx-auto mb-10 leading-relaxed drop-shadow-md">
          Since 2012, your trusted partner for detailed property assessments, offering 24-hour reports and expert local knowledge across South Florida.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-10 py-7 h-auto rounded-[6px] 
              shadow-[inset_0_1px_2px_rgba(255,255,255,0.3),0_8px_20px_rgba(251,146,60,0.3)] 
              hover:scale-105 transition-all duration-300 border border-white/10 group relative overflow-hidden">
            <Link to="#">
              <span className="relative z-10 flex items-center">
                Schedule Inspection
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </span>
              {}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:animate-[shimmer_1.5s_infinite]" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}